import { render } from "./BackComponent.vue?vue&type=template&id=2c058be2&scoped=true"
import script from "./BackComponent.vue?vue&type=script&lang=js"
export * from "./BackComponent.vue?vue&type=script&lang=js"

import "./BackComponent.vue?vue&type=style&index=0&id=2c058be2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c058be2"]])

export default __exports__